// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".979e59929527e94d65c37b75b48bb3b6e78cf701.chunk.bundle.js";
};